export default {
  populate: {
    owner: {
      fields: "id",
    },
    facility_type: {
      fields: "id",
      populate: {
        localizations: {
          fields: ["id", "locale"],
        },
      },
    },
    facility_category: {
      fields: ["id", "name"],
      populate: {
        localizations: {
          fields: ["name", "id", "locale"],
        },
      },
    },
    facility_services: {
      fields: "id",
      populate: {
        localizations: {
          fields: ["id", "locale"],
        },
      },
    },
    image: true,
    gallery: true,
    localizations: true,
  },
};
